import { render, staticRenderFns } from "./user_access_role_badge.vue?vue&type=template&id=1f077309"
import script from "./user_access_role_badge.vue?vue&type=script&lang=js"
export * from "./user_access_role_badge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports